import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NiosAllSubject = () => {
  const [niosClassName, setNiosClassName] = useState("");
  const [reference, setReference] = useState("");
  const [allSubjects, setAllSubjects] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  const handleAddNewClass = () => {
    navigate("/nios-add-subject");
  };

  const handleViewAllClasses = () => {
    navigate("/nios-all-subject");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClasses`)
      .then((resp) => {
        const data = resp.data;
        console.log(data);
        setNiosClassName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const heandleSearch = (e) => {
    e.preventDefault();
    axios
      .get(`${API_BASE_URL}/niosSubjects?classId=${reference}`)
      .then((result) => {
        const data = result.data;
        console.log(data);

        setAllSubjects(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (id) => {
    navigate(`/nios-edit-subject/${id}`);
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this subject?")) {
      axios
        .delete(`${API_BASE_URL}/admin/niosSubject/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(() => {
          setAllSubjects((prevSubjects) =>
            prevSubjects.filter((subject) => subject._id !== id)
          );
          alert("Subject deleted successfully");
        })
        .catch((error) => {
          console.error("Error deleting subject:", error);
          alert("Failed to delete subject");
        });
    }
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Subjects</h5>
        <div className="classes-header-btns">
          <button className="add-class-btn" onClick={handleAddNewClass}>
            + Add New Subject
          </button>
          <button className="all-classes-btn" onClick={handleViewAllClasses}>
            All Subject
          </button>
        </div>
      </div>

      {/* <WelcomeBack /> */}

      <div className="school-all-subject-filter-main">
        <div className="input-group">
          <form onSubmit={heandleSearch}>
            <div style={{ paddingBottom: "10px" }}>
              <label className="label">Select Class</label>
            </div>
            <select
              className="select-dropdown"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              required
            >
              <option value="">-Select Class-</option>
              {niosClassName &&
                niosClassName.map((classes) => (
                  <option value={classes._id} key={classes._id}>
                    {classes?.className}
                  </option>
                ))}
            </select>
            <button className="btn-search ms-3" type="submit">
              Search
            </button>
          </form>
        </div>
      </div>

      <div className="classes-table-container">
        <h5>All Subject</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Subject</th>
              <th>Icon</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}

            {allSubjects.map((data, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{data.subjectName}</td>
                <td>
                  <img
                    src={`${API_BASE_URL}/uploads/${data?.icon}`}
                    alt=""
                    style={{ width: "50px" }}
                  />
                </td>
                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(data._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(data._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NiosAllSubject;
